import clsx from 'clsx';

/**
 * StatusBadge component to display the status of an invoice
 * @param {String} label - 'Rejected', 'Draft', 'Seen'
 * @param {String} status - 'rejected', 'draft', 'seen'
 * @param {*} param0
 */
const StatusBadge = ({ textColor, bgColor, dotColor, label }) => {
  return (
    <p
      className={clsx(
        'flex w-max items-center gap-1.5 rounded-[50px] px-3 py-0.5 text-[11px] font-semibold',
        bgColor,
        textColor
      )}
    >
      <span
        className={clsx('block h-1.5 w-1.5 rounded-full bg-current', dotColor)}
      />
      <span>{label}</span>
    </p>
  );
};

export default function InvoiceStatus({ status }) {
  const action = status?.value || 'draft';
  const label = status?.label;

  return <StatusBadge
    textColor={status.textColor}
    bgColor={status.bgColor}
    label={label}
    status={action}
  />
}
